// src/ConsumerApp/Screens/Home/components/HeroDeliveryCard.js

import React from 'react';
import webHeroBanner from '../images/web.png';

export default function HeroDeliveryCard() {
  return (
    <>
      <style>{`
        .bb-universal-hero-container {
          width: 100%;
          border-radius: 16px;
          overflow: hidden;
          background-color: #F8FAFC;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
          display: block;
          user-select: none;
        }

        .bb-universal-hero-img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
          pointer-events: none;
        }

        @media (max-width: 768px) {
          .bb-universal-hero-container {
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          }
        }
      `}</style>

      <div className="bb-universal-hero-container">
        <img
          src={webHeroBanner}
          alt="Need it urgently? Eligible items at your site in 30-90 mins"
          className="bb-universal-hero-img"
          loading="eager"
        />
      </div>
    </>
  );
}